module.exports = __webpack_public_path__ + "img/image6.138ac12d.png";